import React from 'react';
import { logProGlobalHeaderUpgradeClicked } from '@alltrails/analytics/amplitudeFunctions';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import useUser from 'hooks/useUser';
import * as styles from './styles/styles.module.scss';
import { FormattedMessage } from 'react-intl';
import useFeatureFlags from 'hooks/useFeatureFlags';

const MobileHomeLink = () => {
  const featureFlags = useFeatureFlags();
  const user = useUser();

  if (!user) {
    return (
      <a className={styles.link} href={checkLinkAndAppendLanguage('/signup?ref=homepage_signup_mobileheader')}>
        <FormattedMessage defaultMessage="Sign up" />
      </a>
    );
  }

  return (
    <a
      className={styles.link}
      href={checkLinkAndAppendLanguage('/pro?ref=homepage_pro_mobileheader')}
      onClick={() => logProGlobalHeaderUpgradeClicked()}
    >
      {user.isPromoEligible && featureFlags.sevenDayTrial ? (
        <FormattedMessage defaultMessage="Try Pro" />
      ) : (
        <FormattedMessage defaultMessage="Get Pro" />
      )}
    </a>
  );
};

export default MobileHomeLink;
